import {combineReducers} from "redux";

const initialState = {
    vignetsList: undefined,
    selected_ids: [],
    vignetCount: 0,
    vignetDetail : undefined,
    tagsAdded : false,
    tagsRemoved: false,
    projectAdded : false,
    projectRemoved : false,
    noteAdded : false,
    vignetsDeleted : false,
    vignetCreated : false,
    searchText : '',
    vignetProps : [],
    vignetsMostviewed : undefined,
    recentVignets   : undefined,
    vignetNotes : undefined,
    vignetTags: undefined,
    vignetProjects : undefined,
    graphData : undefined,
    vignetsJoined : false,
    newJoinedUrl : '',
    builderUrl : '',
    projectList : [],
    vignetsGalleryList:[],
    vignetsMadeLive : false,
    vignetsUnsetLive : false,
    userchanged: false,
    modalOpen : false,
    vignetPassSet : false,
    vignetPassReset : false
};

const vignetsData = (state = initialState, action) => {
    var _newState;
    let vignetProps = []
    switch(action.type){
        case "VIGNETS_DATA_REQUEST":
            return  state;
        case "VIGNETS_DATA_SUCCESS":
            return {
                ...state,
                vignetsList : (action.vignetsList && action.vignetsList.data) ? action.vignetsList.data.response:[],
                vignetCount :  (action.vignetsList && action.vignetsList.data  && action.vignetsList.data.response) ? action.vignetsList.data.response.length :state.vignetCount,
                vignetsDeleted : false,
                vignetCreated : false,
                vignetsMadeLive : false,
                vignetsUnsetLive : false

            }
        case "LOAD_MORE_VIGNETS_DATA":
            _newState = {...state};
            _newState['vignetsList'] = _newState.vignetsList.concat((action.vignetsList && action.vignetsList.data) ? action.vignetsList.data.response:[]);
            _newState['vignetCount'] = _newState.vignetsList.length;
            return _newState;
            break;

        case "VIGNETS_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData : action.filteredData ? action.filteredData:state.filteredData,
                vignetCount :  action.filteredData ? action.filteredData.length :state.vignetCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'

            }
        case "VIGNET_DETAIL_SUCCESS":
            return {
                ...state,
                vignetDetail : (action.vignetDetail && action.vignetDetail.data) ? action.vignetDetail.data.response:state.vignetDetail,
                tagsAdded : false,
                tagsRemoved : false
            }
        case "CREATE_VIGNET":
            return {
                ...state,
                vignetCreated  : true,
                builderUrl : (action.created && action.created.data)? action.created.data.builderUrl: state.builderUrl,
            }
        case "SAVE_TAGS":
            return {
                ...state,
                tagsAdded : !state.tagsAdded
            }
        case "REMOVE_TAGS":
            return {
                ...state,
                tagsRemoved : !state.tagsRemoved
            }
        case "SAVE_PROJECTS":
            return {
                ...state,
                projectAdded : !state.projectAdded
            }
        case "REMOVE_PROJECTS":
            return {
                ...state,
                projectRemoved : !state.projectRemoved
            }
        case "SAVE_NOTE":
            return {
                ...state,
                noteAdded : !state.noteAdded
            }
        case "VIGNET_GRAPH":

            let graphData = (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response:[];
            if(action.section_name === 'recent') {
                state.recentVignets[action.index].graphData = graphData;
                return {
                    ...state,
                    recentVignets : state.recentVignets
                }
            }
            else if(action.section_name === 'most_viewed') {
                state.vignetsMostviewed[action.index].graphData = graphData;
                return {
                    ...state,
                    vignetsMostviewed : state.vignetsMostviewed
                }
            }

            return {
                ...state,
                graphData : graphData,
                fbShareCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.fbShareCount:state.fbShareCount,
                waShareCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.waShareCount:state.waShareCount,
                fbViewCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.fbViewCount:state.fbViewCount,
                waViewCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.waViewCount:state.waViewCount
            }

         case 'SELECT_VIGNETS':
            if(state.selected_ids) {
                if(state.selected_ids.includes(action.id)) {
                    var index = state.selected_ids.indexOf(action.id)
                    state.selected_ids.splice(index, 1);
                }
                else{
                    state.selected_ids.push(action.id);
                }
            }

            return {
                ...state,
                selected_ids : state.selected_ids
            }

        case 'CLEAR_VIGNETS':
            return {
                ...state,
                selected_ids : []
            }
        case 'DELETE_VIGNETS':
                return {
                    ...state,
                    selected_ids : [],
                    vignetsDeleted : true
                }
        case 'MAKE_LIVE_VIGNETS':
                return {
                    ...state,
                    selected_ids : [],
                    vignetsMadeLive : true
                }
        case 'UNSET_LIVE_VIGNETS':
            return {
                ...state,
                vignetsUnsetLive : true
            }
        case "VIGNETS_SELECTED":
            return {
            ...state,
            selected_ids : state.selected_ids
        }
        case "GET_VIG_PROPS":

            vignetProps = (action.vignetProps && action.vignetProps.data) ? action.vignetProps.data.response:state.vignetProps;
            if(action.section_name === 'recent') {
                state.recentVignets[action.index].eventTracks = vignetProps;
                return {
                    ...state,
                    recentVignets : state.recentVignets
                }
            }
            else if(action.section_name === 'most_viewed') {
                state.vignetsMostviewed[action.index].eventTracks = vignetProps;
                return {
                    ...state,
                    vignetsMostviewed : state.vignetsMostviewed
                }
            }
            else if(action.section_name === 'list') {
               // state.vignetsList[action.index].eventTracks = vignetProps;
                return {
                    ...state,
                    vignetProps : vignetProps
                }
            }
            else if(action.section_name === 'detail') {
                if(state.vignetDetail) {
                    state.vignetDetail.eventTracks = vignetProps;
                }

                return {
                    ...state,
                    vignetsList : state.vignetsList
                }
            }
        case "SET_VIG_PROPS":
            vignetProps = {"click_count": 0,
                "view_count": 0,
                "pageview_count": 0,
                "hotspot_count": 0,
                "imageclick_count": 0,
                "textclick_count": 0,
                "video_count": 0,
                "comment_count": "0"};


            return {
                ...state,
                vignetProps : vignetProps
            }

        case "GET_VIG_TAGS":
                return {
                    ...state,
                    vignetTags : (action.vignetTags && action.vignetTags.data) ? action.vignetTags.data.response:[]
                }
        case "GET_VIG_NOTES":
                return {
                    ...state,
                    vignetNotes : (action.vignetNotes && action.vignetNotes.data) ? action.vignetNotes.data.response:state.vignetNotes
                }
        case "GET_VIG_PROJECTS":
            return {
                ...state,
                vignetProjects : (action.vignetProjects && action.vignetProjects.data) ? action.vignetProjects.data.response:[]
            }
        case "RECENT_VIGNETS_SUCCESS":
            return {
                ...state,
                recentVignets : (action.vignetList && action.vignetList.data) ? action.vignetList.data.response:state.recentVignets,

            }
        case "VIEWED_VIGNETS_SUCCESS":
            return {
                ...state,
                vignetsMostviewed : (action.vignetList && action.vignetList.data) ? action.vignetList.data.response:state.vignetsMostviewed,

            }
        case "JOIN_VIGNETS":
            return {
                ...state,
                vignetsJoined  : true,
                newJoinedUrl :(action.saved && action.saved.data)? action.saved.data.builderUrl: state.newJoinedUrl,
                selected_ids : []
            }
        case "TOGGLE_VIG_MODAL":
            return {
                ...state,
                modalOpen  : action.modalOpen,
                modalTitle : action.modalTitle,
                modalType  : action.modalType
            }
        case "LOAD_PROJECT_DATA" :
            return {
                ...state,
                projectList  :  (action.projectList && action.projectList.data) ? action.projectList.data.response:[],
            }

        case "GET_VIG_GLRY":
            console.log(action)
            return {
                ...state,
                vignetsGalleryList :  (action.vignetGallery && action.vignetGallery.data) ? action.vignetGallery.data.response:[],
            }

        case "CHANGED_USER":
            return {
                ...state,
                userchanged : !state.userchanged,
                selected_ids : []

            }
        case "GET_VGLRY_DET":
            console.log(action)
            return {
                ...state,
                vignetsGalleryDetail :  (action.vignetGdetail && action.vignetGdetail.data) ? action.vignetGdetail.data.response:[],
            }
        case "SAVED_VIG_PASS" :
            return {
                ...state,
                vignetPassSet :  action.vignetPassSet
            }
        case "REMOVED_VIG_PASS" :
            return {
                ...state,
                vignetPassReset :  action.vignetPassReset
            }
        default:
            return state;
    }

}
const getSelectedItems = (state = {},action) => {
    switch (action.type) {
        case "SET_SELECTED_ITEMS" :
            return {
                ...state,
                [action.name] : action.value
            };
            break;
        default:
            return state;

    }
}

const vignets = combineReducers({
    vignetsData,
    getSelectedItems
})

export default vignets;
//export const getVignetsData = state => state.vignets.vignetsData;



// WEBPACK FOOTER //
// ./src/reducers/vignets.js